const dictionary = {
    pt: {
      messages: {
        cpf: () => 'CPF inválido',
        cnpj: () => 'CNPJ inválido',
        required: (field) => `Este campo é obrigatório.`,
        min: (e,n) => "Campo deve conter ao menos "+n[0]+" caracteres.",
        min_value: (e,n) => "Valor mínimo permitido é "+n[0]+".",
        max: (e,n) => "Campo deve conter no máximo "+n[0]+" caracteres.",
        max_value: (e,n) => "Valor máximo permitido é "+n[0]+".",
        digits: (e,n) => "Este campo deve conter "+n[0]+" caracteres.",
        email: () => "E-mail inválido.",
        numeric: () => "Campo deve conter somente números",
        zero: () => "Este campo é obrigatório.",
        'valida-zero': (field, args) => `Este campo é obrigatório.`,
      }
    }
  }
  export default dictionary



// WEBPACK FOOTER //
// ./src/shared/dictionaryPT.js